export default {
  path: '/material_product_versions',
  name: 'material_product_versions',
  component: () => import('../components/materialproductversion/Layout'),
  redirect: { name: 'MaterialProductVersionList' },
  meta: {
    breadcrumb: 'profile.material.productversions',
  },
  children: [
    {
      name: 'MaterialProductVersionList',
      path: '',
      component: () => import('../views/materialproductversion/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'MaterialProductVersionCreate',
      path: 'new',
      component: () => import('../views/materialproductversion/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'MaterialProductVersionUpdate',
      path: ':id/edit',
      component: () => import('../views/materialproductversion/Update'),
      meta: {
        breadcrumb: 'profile.material.productversion',
      },
    },
    {
      name: 'MaterialProductVersionShow',
      path: ':id',
      component: () => import('../views/materialproductversion/Show'),
      meta: {
        breadcrumb: 'profile.material.productversion',
      },
    },
    {
      name: 'MaterialProductVersion',
      path: ':parent',
      component: () => import('../components/producttypefile/Layout'),
      meta: {
        breadcrumb: 'qualitycheck.product.producttypefiles',
      },
      children: [
        {
          name: 'ProducttypefileMaterialProductVersionCreate',
          path: 'new',
          component: () => import('../views/producttypefile/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
      ]

    },
  ]
};
